'use client'
export const getClientsideQueryString = (input: string) => {
  let query = window?.location?.search
  if (!query) return null
  query = query.substring(1)
  const split = query.split('&')
  const queries = []
  split.forEach(q => {
    const [key, value] = q.split('=')
    queries.push({ key, value })
  })
  const queryExists = queries.find(({ key }) => key === input)
  if (queryExists) {
    return queryExists.value
  } else {
    return null
  }
}
